<template>
  <div class="hero">
    <div class="hero__container">
      <h1 class="hero__title">{{ title }}</h1>
      <p class="hero__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #4D89B8;
$white: #ffffff;
$spacing-base: 1rem;

.hero {
  background-color: $primary-color;
  color: $white;
  padding: $spacing-base * 4 0;
  padding-top: calc(82px + #{$spacing-base * 4}); // Account for fixed nav
  
  &__container {
    max-width: 64rem;
    margin: 0 auto;
    padding: 0 $spacing-base;
    text-align: center;
  }

  &__title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: $spacing-base;
  }

  &__subtitle {
    font-size: 1.25rem;
    opacity: 0.9;
  }
}
</style> 